import SockJS from "sockjs-client";
import Stomp from "webstomp-client";
import AuthService from "../../services/planning/AuthService.js";
import i18n from "@/i18n";


import {
  getAllInterventionsFollowedByInterventionIdHttp
} from "../../services/planning/InterventionFollowedService.js";

  const state = {
    sendMessage: null,
    connection: false,
    socket: null,
    stompClient: null,
  };

  const getters = {
    getConnection(state) {
      return state.connection;
    },
    getSocket(state) {
      return state.socket;
    },
    getStompClient(state) {
      return state.stompClient;
    },
    getSendMessage(state) {
      return state.sendMessage;
    }
  };

  const mutations = {
    SET_CONNECTION: (state, payload) => (
      state.connection = payload
    ),
    SET_SEND_MESSAGE: (state, payload) => (
      state.sendMessage = payload
    )
  };

  const actions = {
    /**
     * This method connects the client to the WebSocket. It allows to have real time data for events.
     * This method gather the connection + subscription to the WebSocket.
     * 
     * @param  {Vuex} {commit necessary if call commit inside the method
     * @param  {Vuex} getters necessary if call getters inside the method
     * @param  {Vuex} rootGetters} necessary if we want to call getters from another store
     */
    async connectToWebsocket({ commit, dispatch, getters, rootGetters }) {
      getters.socket = new SockJS(process.env.VUE_APP_WS);
      getters.stompClient = Stomp.over(getters.socket);
      getters.stompClient.debug = () => {}; // disable debug messages on sockjs
      getters.stompClient.connect({'X-Authorization': AuthService.getBearerToken()}, frame => {
        commit("SET_CONNECTION", true);
        getters.stompClient.subscribe("/topic/messages", response => {
          let type = JSON.parse(response.body).type;
          let id = parseInt(JSON.parse(response.body).id);
          let event = JSON.parse(JSON.parse(response.body).event);
          
          switch (type) {
            case 'ADD':
              let eventExisting = rootGetters["eventModule/getEvents"].findIndex(
                (e) => e.id === event.id
              );
              if(eventExisting === -1 ) 
                commit('eventModule/NEW_EVENT', event, { root: true });
              break;
            case 'EDIT':
              commit('eventModule/EDIT_EVENT', event, { root: true });
              dispatch('interventionFollowedModule/reloadInterventionFollowedByInterventionId', event.details.id, { root : true});
              break;
            case 'DELETE':
              commit('eventModule/REMOVE_EVENT', id, { root: true });
              commit('interventionFollowedModule/REMOVE_INTERVENTIONFOLLOWED_FOR_INTERVENTION_ID', id, {root : true});
              break;
            default:
              // Manage error
              break;
            }
        }, { id: "myCalendarId"});
      },
        error => {
          // Manage error
          commit("SET_CONNECTION", false);
        }
      );
    },
    /**
     * This method disconnect the client from the WebSocket.
     * 
     * @param  {Vuex} {commit necessary if call commit inside the method
     * @param  {Vuex} getters} necessary if call getters inside the method
     */
    async logoutFromWebsocket({ commit, dispatch, getters }) {
      if (getters.stompClient) {
        getters.stompClient.unsubscribe("myCalendarId");
        getters.stompClient.disconnect();
      }
      commit("SET_CONNECTION", false);
      dispatch(
        "notificationModule/showNotification",
        {
          messageAlert: i18n.t("messageToken.sessionExpired"),
          typeAlert: "error",
        },
        { root: true }
      );
    },
    /**
     * This method allows the client to send messages to WebSocket if he is connected before (method connectToWebsocket()).
     * 
     * @param  {Vuex} {getters} necessary if call getters inside the method
     * @param  {} message
     */
    async sendMessageToWebsocket({ getters }, message) {
      if (getters.stompClient && getters.stompClient.connected) {
        getters.stompClient.send("/app/chat", JSON.stringify(message.messageWS), {'token': AuthService.getBearerToken()});
      }
    },
  };

  export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
  };

